{
  "enum": {
    "IxcMfrecoV1BreakReason": {
      "LEDGER_MISSING": "Ledger Missing",
      "SHARES_DIFFER": "Shares Differ",
      "UNSPECIFIED": "Unspecified",
      "VENUE_MISSING": "Venue Missing"
    },
    "IxcMfrecoV1PositionDayStatus": {
      "BREAK": "Break",
      "MATCHED": "Matched",
      "PENDING": "Pending",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcMfrecoV1PositionDayQueryServicePositionDayListFilterableFields": {
      "assetId": "Asset",
      "data": {
        "breakReason": "Break Reason",
        "difference": "Difference",
        "fund": {
          "cusip": "Fund CUSIP"
        }
      },
      "date": "Date",
      "status": "Status",
      "venue": "Venue"
    }
  },
  "oneOf": {
    "IxcMfrecoV1PositionDayEventType": {
      "break": "Break",
      "caseOpened": "Case Opened",
      "ledgerReported": "Ledger Reported",
      "matched": "Matched",
      "venueReported": "Venue Reported"
    },
    "IxcMfrecoV1VenueSource": {
      "jpmam": "JPMAM"
    }
  },
  "searchEnum": {
    "IxcMfrecoV1PositionDayQueryServicePositionDayListSearchableFields": {
      "data": {
        "fund": {
          "name": "Fund Name",
          "symbol": {
            "base": "Fund Symbol Base"
          }
        }
      }
    }
  },
  "sortEnum": {
    "IxcMfrecoV1PositionDayQueryServicePositionDayListSortableFields": {
      "data": {
        "difference": "Difference"
      },
      "date": "Date",
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}